import { fetchUtils, Resource } from 'react-admin';
import { stringify } from 'query-string';
import { useSelector } from 'react-redux';

const REACT_APP_URL_API = process.env.REACT_APP_URL_API;

const REACT_APP_SERVER_API = process.env.REACT_APP_SERVER_API;
const REACT_APP_PORT_API = process.env.REACT_APP_PORT_API || 3001;
const REACT_APP_PATH_API = process.env.REACT_APP_PATH_API;
const REACT_APP_PATH_API_PAYMENT = process.env.REACT_APP_PATH_API_PAYMENT || 'payments'
const REACT_APP_PATH_API_COURSE = process.env.REACT_APP_PATH_API_COURSE;
const REACT_APP_PATH_API_VIDEO = process.env.REACT_APP_PATH_API_VIDEO;
const REACT_APP_PATH_API_IMAGE = process.env.REACT_APP_PATH_API_IMAGE
const REACT_APP_PATH_API_USER = process.env.REACT_APP_PATH_API_USER;
const REACT_APP_PATH_API_ROLES = process.env.REACT_APP_PATH_API_ROLES || 'roles';
const REACT_APP_PATH_API_NEWS = process.env.REACT_APP_PATH_NEWS || 'news'

const BASE_COURSE_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_COURSE}`;
const BASE_VIDEO_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_VIDEO}`;
// const apiUser = 'http://localhost:3001/api/v1/user/profile';
// const apiRoles = 'http://localhost:3001/api/v1/roles';
const BASE_IMAGE_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_IMAGE}`
const BASE_PAYMENT_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_PAYMENT}`
const BASE_NEWS_URL = `${REACT_APP_SERVER_API}:${REACT_APP_PORT_API}/${REACT_APP_PATH_API}/${REACT_APP_PATH_API_NEWS}`
// console.log(`Base URL for courses: ${BASE_COURSE_URL}`);

const myDataProvider = {
  getList: async (resource, params) => { //
    const token = localStorage.getItem('token');
    if (resource === 'courses') {       //solicita el recurso "curso" de la lista de curso
      const query = {
        title: params.filter.title || '',
        isPublished: params.filter.isPublished, //se crea un objeto con title para hacer la cadena de consulta ,evita que si la consulta esta vacia rompa la url
      };

      const url = `${REACT_APP_URL_API}/course/filter?${stringify(query)}`;//convierte el objeto en una cadena de url valida
      const options = {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token || null}`
        }),
        credentials: 'include', //para que envie las cookies
      };
      const response = await fetchUtils.fetchJson(url, options);
      const courses = response.json.courses || response.json;

      return {                                   //devuelve un objeto con los datos del recurso y el total
        data: courses.map(course => ({ ...course, id: course.id })),
        total: courses.length,
      };
    }
    if (resource === 'videos') {
      const url = `${REACT_APP_URL_API}/video/search`
      const response = await fetchUtils.fetchJson(url);
      const videos = response.json.video || response.json;
      return {
        data: videos.map(video => ({ ...video, id: video.id })),
        total: videos.length,
      };
    }
    if (resource === 'images') {
      const url = `${REACT_APP_URL_API}/image/cloudinary`
      console.log("Petición a images:", url);

      const response = await fetchUtils.fetchJson(url);
      const images = response.json

      console.log("imagenes recibidas", images)

      return {
        data: images.map(image => ({
          ...image,
          id: image.id,
        })),
        total: images.length,
      }
    }
    if (resource === 'users') {
      const url = `${REACT_APP_URL_API}/user/profile/all`;
       const token = localStorage.getItem('token');
      const options = {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token || null}`
        }),
        credentials: 'include', //para que envie las cookies
      };
      const response = await fetchUtils.fetchJson(url,options);

      const users = response.json || [];
      return {
        data: users.map(user => ({ ...user, id: user.id })),
        total: users.length
      }
    }
    if (resource === 'roles') {
      const url = `${REACT_APP_URL_API}/roles/allRoles`;
      const response = await fetchUtils.fetchJson(url);
      const roles = response.json || [];
      return {
        data: roles.map(role => ({ ...role, id: role.id })),
        total: roles.length
      }
    } if (resource === 'payments') {
      let url = `${REACT_APP_URL_API}/payments/mp`;

      if (params.filter.status) {
        url += `?status=${encodeURIComponent(params.filter.status)}`;
      }

      const response = await fetchUtils.fetchJson(url);
      const payments = response.json || [];

      return {
        data: payments.map((payment) => ({ ...payment, id: payment.id })),
        total: payments.length,
      };

    }if(resource ==='news'){  
       const query = {
        title: params.filter.title || '',
        isPublished: params.filter.isPublished, //se crea un objeto con title para hacer la cadena de consulta ,evita que si la consulta esta vacia rompa la url
        };
         
       const url =` ${REACT_APP_URL_API}/news/allNews`;
       const options = {
        method:'GET',
        headers: new Headers({
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token || null}`
        }),
        //credentials:'incluide', //para enviar las cookies
         credentials: 'include',
         body: JSON.stringify(params.data)
        };
       const response = await fetchUtils.fetchJson(url,options);
       const newsList = response.json || [];

         return {
           data: newsList.map(item => ({ ...item, id: item.id })),
           total: newsList.length
  };
     
    }

    return Promise.reject(`Unknown resource: ${resource}`);
  },

  create: async (resource, params) => {
    const token = localStorage.getItem('token') || null;
    if (resource === 'courses') {
      const url = `${REACT_APP_URL_API}/course/add`;
      const options = {
        method: 'POST',
        headers: new Headers(
          {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        ),
        credentials: 'include',
        body: JSON.stringify(params.data), //aca van los datos que se desean crear
      };
      const response = await fetchUtils.fetchJson(url, options);

      return { data: { ...response.json, id: response.json.id } };
    }
    if (resource === 'videos') {
      const url = `${REACT_APP_URL_API}/video/new`;
      const options = {
        method: 'POST',
        body: JSON.stringify(params.data),
      };
      const response = await fetchUtils.fetchJson(url, options);
      return { data: { ...response.json, id: response.json.id } }
    }
    if (resource === 'users') {
      const url = `${REACT_APP_URL_API}/user/profile/createAdmin`;
      const options = {
        method: 'POST',
        body: JSON.stringify(params.data),
        headers: new Headers({ 'Content-Type': 'application/json' })
      };
      const { json } = await fetchUtils.fetchJson(url, options)
      return { data: { ...json, id: json.id } }
    }

    
    if (resource === 'news') {  
      const url = `${REACT_APP_URL_API}/news/newAdd`;
      const options = {
        method: 'POST',
        headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
        }),
        credentials: 'include',
        body: JSON.stringify(params.data)
      };
     const response = await fetchUtils.fetchJson(url, options);
     return { data: { ...response.json, id: response.json.id } };
    }


    return Promise.reject(`Unknown resource: ${resource}`);
  },


  getMany: async (resource, params) => {
    if (resource === 'roles') {
      let url = `${REACT_APP_URL_API}/roles/allRoles`;
      const response = await fetchUtils.fetchJson(url);
      const roles = response.json || [];


      // Filtra los roles que coincidan con los IDs solicitados
      const filtered = roles.filter(role => params.ids.includes(role.id));

      return {
        data: filtered.map(role => ({ ...role, id: role.id })),
      };
    }
    return Promise.reject(`Unknown resource in getMany: ${resource}`);
  },

  deleteMany: async (resource, params) => {
    if (resource === 'courses') {
      await Promise.all(
        params.ids.map(id =>
          fetchUtils.fetchJson(`${REACT_APP_URL_API}/course/delete/${id}`, { method: 'DELETE' })
        )
      );
      return { data: params.ids };
    }
    if (resource === 'videos') {
      await Promise.all(
        params.ids.map(id =>
          fetchUtils.fetchJson(`${REACT_APP_URL_API}/video/delete/${id}`, { method: 'DELETE' }
          )
        )
      );
      return { data: params.ids };
    }

    if (resource === 'users') {
      const url = `${REACT_APP_URL_API }/user/profile/bulk`;
      const options = {
        method: 'DELETE',
        body: JSON.stringify({ ids: params.ids }),
      };

      const { json } = await fetchUtils.fetchJson(url, options);
      return { data: json.data };
    }
    if (resource === 'news') {
  await Promise.all(
    params.ids.map(id =>
      fetchUtils.fetchJson(`${REACT_APP_URL_API}/news/delete/${id}`, { method: 'DELETE' })
    )
  );
  return { data: params.ids };
}

    return Promise.reject(`Unknown resource: ${resource}`);
  },

  getOne: async (resource, params) => { //para obtener un recurso especifico
 const token = localStorage.getItem('token');
    if (resource === 'courses') {
    const url = `${REACT_APP_URL_API}/course/${params.id}`;//chequear si esta bien!! la ruta
    const options = {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`,
      }),
    };
    const response = await fetchUtils.fetchJson(url, options);
    return { data: { ...response.json, id: response.json.id } };
  }

    if (resource === 'videos') {
      const url = `${REACT_APP_URL_API}/video/${params.id}`;
      const response = await fetchUtils.fetchJson(url);
      return { data: { ...response.json, id: response.json.id } };
    }
    if (resource === 'users') {
      const url = `${REACT_APP_URL_API }/user/profile/${params.id}`;
      const options = {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`,
      }),
    }
      const response = await fetchUtils.fetchJson(url);
      return {
        data: { ...response.json, id: response.json.id }
      };
    }

    if (resource === 'roles') {
      const url = `${REACT_APP_URL_API}/roles/allRoles`;
      const response = await fetchUtils.fetchJson(url);
      const roles = response.json || [];
      const found = roles.find(role => role.id === params.id);
      if (!found) throw new Error('Rol no encontrado');
      return { data: { ...found, id: found.id } };
    }
    if (resource === 'news') {

      const url = `${REACT_APP_URL_API}/news/send/${params.id}`;
      const options = {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`,
      }),
       credentials: 'include'
    };
      const response = await fetchUtils.fetchJson(url, options);
      const data = response.json;
      return {
       data: { ...response.json, id: response.json.id }
      };
   }

    return Promise.reject(`Unknown resource: ${resource}`);
  },


  update: async (resource, params) => {
    const token = localStorage.getItem('token');
    if (resource === 'courses') {
      console.log("datos enviados al back:", params.data);
      const url = `${REACT_APP_URL_API}/course/update/${params.id}`;
      const options = {
        method: 'PUT',
        body: JSON.stringify(params.data),
         headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`,
      }),
      };
      const response = await fetchUtils.fetchJson(url, options);
      return { data: { ...response.json, id: response.json.id } };
    }
    if (resource === 'videos') {
      const url = `${REACT_APP_URL_API}/video/order/${params.id}`;
      const options = {
        method: 'PUT',
        body: JSON.stringify(params.data),
      };
      const response = await fetchUtils.fetchJson(url, options);
      return { data: { ...response.json, id: response.json.id } };
    }
    if (resource === 'users') {
      const url = `${REACT_APP_URL_API}/user/profile/update/${params.id}`;
      const options = {
        method: 'PUT',
        body: JSON.stringify(params.data),
        headers: new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token || ''}`,
      }),
      };
      const response = await fetchUtils.fetchJson(url, options);
      return { data: { ...response.json, id: response.json.id } }
    }

    if (resource === 'news') {  
  const url = `${REACT_APP_URL_API}/news/update/${params.id}`;
  const options = {
    method: 'PUT', 
    body: JSON.stringify(params.data),   
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }),
    
  };
  const response = await fetchUtils.fetchJson(url, options);
  return { data: { ...response.json, id: response.json.id } };
}

    return Promise.reject(`Unknown resource: ${resource}`);
  },
};

export default myDataProvider;
